export { Clipboard } from './Clipboard'
